import { binSelectors as selector } from "../Selectors/index";
import BinService from "../../Service/Item-master/itemBin.service";
import { openSnackbar } from "./snackbarActions";

export const getBin = () => {
  return {
    type: selector.GET_BIN,
  };
};

export const getBinSuccess = (bin) => {
  return {
    type: selector.GET_BIN_SUCCESS,
    payload: bin,
  };
};

export const fetchBin = () => {
  return async (dispatch) => {
    dispatch(getBin());
    try {
      const res = await BinService.getAll();
      dispatch(getBinSuccess(res));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
};
